import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const CommunicationPipelineDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_communicationPipeline_home"
  />
);

export default CommunicationPipelineDefaultWidget;
